const PlaceholderSlider = ({height = '40rem'}) => {
    return (
        <div className="carousel-inner">
            <div className="placeholder-image" style={{ height: height, backgroundColor: '#e0e0e0' }}>
                <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                    <div className="placeholder-title" style={{ height: '20px', width: '40%', backgroundColor: '#e0e0e0', margin: '10px auto', opacity: '30%', marginTop: height <= '40rem' ? '110px' :'0' }}></div>
                    <div className="placeholder-text" style={{ height: '30px', width: '60%', backgroundColor: '#e0e0e0', margin: '10px auto', opacity: '60%' }}></div>
                    <div className="placeholder-title" style={{ height: '20px', width: '30%', backgroundColor: '#e0e0e0', margin: '10px auto',  opacity: '30%' }}></div>
                    <div className="placeholder-button" style={{ height: '30px', width: '100px', backgroundColor: '#e0e0e0', margin: '10px auto', borderRadius: '10px' }}></div>
                </div>
            </div>
        </div>
    );
}

export default PlaceholderSlider;
